<template>
    <!-- 招標案件編輯畫面之 報價明細 -->
        <CCard>
            <CCardBody>
                <div class="mb-2">
                    <strong>需求內容: </strong> 
                    <a v-for="(item,key) in filterExcelTemplateList" :key="key" class="ml-4" target="_blank" :href="downloadExcelLink(item)">{{showDownloadTxt(item)}}</a>
                    <div class="attachment mt-2" v-if="!isView" >
                        <p>需求附件: </p>
                        <input type="file" v-if="showFile" @change="onFileSelection">
                        <a class="fileLink" v-if="showFileLink(quoteRow)" target="_blank" :href="getFileLink(quoteRow)">{{getUploadFileName(quoteRow)}}</a>
                        <button type="button" class="btn btn-success mr-2" @click="uploadConfirm">{{i18n('Buttons.Confirm')}}</button>
                        <button type="button" class="btn btn-danger mr-2" @click="deleteExcelEvent">{{i18n('Buttons.Delete')}}</button>
                    </div>
                    <div v-else>
                        <a class="fileLink" v-if="showFileLink(quoteRow)" target="_blank" :href="getFileLink(quoteRow)">{{getUploadFileName(quoteRow)}}</a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-7">
                        <table class="table">
                            <thead class="thead-light">
                                <tr>
                                    <th :class="header[1]" v-for="(header,index) in getTableHeader()" :key="header[0]"  v-c-tooltip="toolTipHandle(header[0],index)">{{ header[0] }}</th>                                                                
                                </tr>
                            </thead>
                            <tbody v-if="hadTableRows"> 
                                <tr v-for="trData in getTableBody()" :key="trData.guid">
                                    <td v-for="(tdData , index) in trData.row" :class="getCssForTd(index)" :key="index">{{ tdData }}</td>
                                </tr>                              
                            </tbody>
                        </table>
                    </div>                    
                </div>
            </CCardBody>
        </CCard>
    <!-- </div> -->
</template>
<script>
//import { mapActions } from 'vuex'
export default {
    data() {
        return {                 
            tableHeaderMap : {
                docType_11:  [
                    ['項次','text-center'],
                    ['物料','text-center'],
                    ['短文','text-center'],
                    ['訂購單位','text-center'],
                    ['年交易量','text-center'],
                    ['月平均量','text-center'],
                    ['招標價格未稅','text-center']
                ] , //五金文具3
                docType_12:  [
                    ['序號','text-center'],
                    ['料號','text-center'],
                    ['品名','text-center'],
                    ['單位','text-center'],
                    ['照片','text-center'],
                    ['報價(RMB/元/未稅)','text-center']
                ] , //廢品4
                docType_13:  [
                    ['序號','text-center'],
                    ['運輸路線','text-center'],
                    ['租車模式','text-center'],
                    ['車型要求','text-center'],
                    ['去程報價','text-center'],
                    ['回程報價','text-center']
                ] , //物流3
                docType_2:  [
                ['編號','text-center'],
                ['品名','text-center'],
                ['規格','text-center'],
                ['型號','text-center'],
                ['廠牌','text-center'],
                ['單位','text-center'],
                ['數量','text-center'],
                ['單價','text-center'],
                ['總價','text-center'],
                ['備註','text-center']
                ] //工程5
            },
            otherTableHeader : [],
            tableBody: [],
            excelTemplateList: [],
            showFile: true,            
            upExcelFileObj: { } ,
            canQuoteDetail : this.isEdit,
            numDataColStartIndex : 3, //資料欄，從第幾欄開始為數值欄位
            actUploadAddFiles: '',
            checkSaveFile: false,    //  判斷是否檔案會確認而送出
        }
    },
    props : {
        quoteRow : Object,
        isEdit: Boolean,
        currentVendorId : String,
        isView : {
            type: Boolean ,
            default: false
        }
    },
    watch: {
        'quoteRow.requestType': function(v) {            
            if(v){
                if(this.canQuoteDetail){
                    const caseClose = this.quoteRow.caseClosed;
                    if(caseClose === 'N' || this.isMember){
                        this.queryRequestForQuoteDetail();
                    } else if(caseClose === 'Y' || caseClose === 'X'){     
                        const quoteDetailResult = this.quoteRow.vendorQuoteDetailResult;
                        if(quoteDetailResult && quoteDetailResult.needVendorQuotation){                            
                            this.otherTableHeader =quoteDetailResult.needVendorQuotation;
                        }
                        this.tableBody = this.quoteRow.vendorQuoteDetailList;
                    }
                    
                } 
            }
        },
        checkSaveFile: function() {
            this.$emit('confirmFile', this.checkSaveFile)
        }
    },
    computed :{
        quoteid (){             
            if(this.quoteRow){
                return this.quoteRow.guid;
            }
            return '';
        },
        filterExcelTemplateList (){            
            if(this.quoteRow && this.quoteRow.requestType){                
                const v= this.quoteRow.requestType;
                return this.excelTemplateList.filter((e)=>{ 
                    return (e.requestType === v) ;
                });
            }
            return [];
        },
        hadTableRows (){
            if(this.tableBody && this.tableBody.length >0){
                return true;
            }
            return false;
        },
        headerCount (){
            let h = this.getTableHeaderWithoutVal();
            return h.length;
        },
        QuotationDetailLabel (){
            if(this.isMember){//供應商
                return this.$t('QuoteInfo_Vue.QuotationDetail2');
            }else{
                return this.$t('QuoteInfo_Vue.QuotationDetail');
            }
        }
    },
    methods: {
        //...mapActions(['getExcelTemplateList']),
        getTableHeaderWithoutVal (){
            let header = [];            
            if(this.quoteRow && this.quoteRow.requestType){
               const requestType = this.quoteRow.requestType;
               let headerKey='';
               if(requestType === '11' || requestType === '12' || requestType === '13'){
                    headerKey= 'docType_' + requestType;                    
               }else if(requestType === '21' || requestType === '22' ){
                   headerKey= 'docType_2';                   
               }
               if(headerKey){
                    header = [...this.tableHeaderMap[headerKey]];                    
               }               
            }
            return header;
        },
        getTableHeader (){
            let header = this.getTableHeaderWithoutVal();            
            const caseClose = this.quoteRow.caseClosed;
            if(caseClose === 'X'){
                return header; //作廢標單，不會看到供應商報價的單價和金額
            }
            //廠商報價標題整理與呈現
            const otherH = this.otherTableHeader;
            if(otherH && otherH.length >0){
                otherH.forEach(e=>{
                    header.push([e.vendorName,'vendorStyle calcCal']);
                });   
                header.push(['最低報價','calcCal']);  
            }
            return header;
        },
        getTableBody (){
            const trBody = [];
            const Rows = this.tableBody;
            if(Rows && Rows.length){
                const requestType = this.quoteRow.requestType;
                let calcSum = true;
                const caseClose = this.quoteRow.caseClosed;
                if(caseClose === 'X'){
                    calcSum = false; //作廢標單，不會看到供應商報價的單價和金額
                }
                if(requestType === '11'){
                    this.numDataColStartIndex =3;
                }else if(requestType === '12'){
                    this.numDataColStartIndex =4;
                }else if(requestType === '13'){
                    this.numDataColStartIndex =3;
                }else if(requestType === '21' || requestType === '22' ){
                    this.numDataColStartIndex =5;
                }
                Rows.forEach(r=>{
                    const item ={guid: r.guid ,row: [] };
                    if(requestType === '11'){
                        item.row.push(r.productNo);
                        item.row.push(r.productName);
                        item.row.push(r.specification);
                        item.row.push(r.unit);
                        item.row.push(r.annualQuantity);
                        item.row.push(r.monthlyQuantity);
                        item.row.push(r.priceTaxExcluded);
                    }else if(requestType === '12'){
                        item.row.push(r.iNo);
                        item.row.push(r.productNo);
                        item.row.push(r.productName);
                        item.row.push(r.unit);
                        item.row.push(r.image);
                        item.row.push(r.priceTaxExcluded);
                    }else if(requestType === '13'){
                        item.row.push(r.iNo);
                        item.row.push(r.routeName);
                        item.row.push(r.specification);
                        item.row.push(r.model);
                        item.row.push(r.quoteForOutbound);
                        item.row.push(r.quoteForReturn);
                    }else if(requestType === '21' || requestType === '22' ){
                        item.row.push(r.productNo);
                        item.row.push(r.productName);
                        item.row.push(r.specification);
                        item.row.push(r.model);
                        item.row.push(r.label);
                        item.row.push(r.unit);
                        item.row.push(r.quantity);
                        item.row.push(r.price);
                        item.row.push(r.total);
                        item.row.push(r.detailMemo);               
                    }                    
                    trBody.push(item);
                });
                //廠商報價金額整理與呈現
                if(calcSum){
                    const currencyF2Filter = this.$options.filters['currencyF2'];
                    const convertMoney = this.convertMoney;
                    const otherH = this.otherTableHeader;
                    let quoteValueForVendorId = '';
                    if(this.quoteRow && this.quoteRow.vendorQuoteDetailResult){
                        quoteValueForVendorId = this.quoteRow.vendorQuoteDetailResult.quoteValueForVendorId;
                    }
                    if(otherH && otherH.length >0 && quoteValueForVendorId){
                        let ii =0;                    
                        trBody.forEach(r=>{
                            const item =r.row;
                            otherH.forEach(e=>{
                                const r2 = quoteValueForVendorId[e.vendorId];
                                if(r2 && r2.length > ii){
                                    item.push(convertMoney(r2[ii] , currencyF2Filter));
                                }else{
                                    item.push('');
                                }
                            });  
                            const r3 = quoteValueForVendorId['[LowestPrice]'];
                            if(r3 && r3.length > ii){
                                item.push(convertMoney(r3[ii] , currencyF2Filter));
                            }else{
                                item.push('');
                            }
                            ii++;
                        });
                    }
                }
            }
            return trBody;
        },
        convertMoney(val , currencyF2Filter){
            if(val || val === 0){
                return currencyF2Filter(val);
            }
            return ''
        },
        downloadExcelLink (item) {// Excel 範本下載，區分採購人員/供應商不同連結定義
            let quoteid = this.quoteid;
            const excelGuid = item.guid;                        
            if(this.isMember){//供應商
                if(quoteid){
                    return `${this.$apiUrl_Quotation}/DownloadSampleExcel/${quoteid}`;
                }
            }else{//採購人員
                if(!quoteid){
                    quoteid  = 'new';
                }
                if(excelGuid && !this.isView){
                    return `${this.$apiUrl_Quotation}/GetExcelTemplate/${quoteid}/${excelGuid}`;
                }
            }
            return '#';
        },
        showDownloadTxt(item){            
            if(!this.isMember){//採購人員
                if(this.isView){//僅可查看
                    return '';
                }
            }
            if(item.excelFiles){
                let file = item.excelFiles;
                const ii = file.indexOf('\\');
                if(ii > -1){
                    file = file.substring(ii+1);
                }
                return file;
            }
            return '';
        },
        onFileSelection (e) { //--檔案挑選後，判斷並處理此檔案物件
            const maxFileByte = 5242880;            
            const acceptedImageTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            // add all selected files
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return false;
            this.upExcelFileObj = {};
            this.checkSaveFile = false;
            const self = this;
            let file = files[0];
            let fileType = file['type'];
            this.upExcelFileObj.fileType = fileType;
            this.upExcelFileObj.fileName = file.name;
            this.checkSaveFile = true;
            let isAccpetType = acceptedImageTypes.includes(fileType);           
            if (!isAccpetType) {
                e.target.value = '';
                this.$alert('檔案格式需為 Excel (Excel 2007 以上版本)，請重新上傳!','警告',{type: 'warning'});
            } else if (maxFileByte < file.size) {
                e.target.value = '';
                this.$alert('檔案大小需5Mb以下，請重新上傳!','警告',{type: 'warning'});
            } else {
                //this.showFileText = file.name
                const reader = new FileReader();
                reader.readAsDataURL(file);                                 
                reader.onload = function(event) {
                    var base64result = reader.result.substr(event.target.result.indexOf(',') + 1);
                    self.upExcelFileObj.fileBase64 = base64result;                    
                };
            }             
        },
        uploadConfirm (){//確定上傳
            if(!(this.upExcelFileObj && this.upExcelFileObj.fileBase64)){
                this.$alert('需挑選報價附件檔案!','警告',{type: 'warning'});
                return;
            }
            const self =this;
            const param = {quoteId : this.quoteid , vendorId: this.currentVendorId ,excelFileBinary: null ,requestType : this.quoteRow.requestType};
            param.excelFileBinary = this.upExcelFileObj.fileBase64; //base64 字串 ，原始 --> ABC123456 --> QUJDMTIzNDU2
            param.fileType = this.upExcelFileObj.fileType;
            param.fileName = this.upExcelFileObj.fileName;
            this.checkSaveFile = false;
            let url = `${this.$apiUrl_Quotation}/UploadExcelFile`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                //this.showFile = false;
                const {status , statusMessage} = response.data;
                if(status){
                    self.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--上傳完成，讀取清單資料呈現
                    self.queryRequestForQuoteDetail();
                    //self.quoteRow.addFiles = param.fileName;
                    self.actUploadAddFiles = param.fileName;
                    self.quoteRow.fileName = param.fileName;
                    // this.$nextTick(()=> {
                    //     this.showFile = true;
                    // });
                }                
                this.updateLoading(false);
            }).catch(()=> {
                this.updateLoading(false);
            });
        },
        deleteExcelEvent (){
            const self =this;
            this.$confirm('此操作將永久刪除該文件, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                self.deleteExcel();
            });
        },
        deleteExcel (){//刪除上傳
            const self =this;
            const param = {quoteId : this.quoteid , vendorId: this.currentVendorId ,excelFileBinary: 'bnVsbA==' ,requestType : this.quoteRow.requestType}; //bnVsbA== --> null
            let url = `${this.$apiUrl_Quotation}/DeleteExcelFile`;
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--刪除完成，讀取清單資料呈現
                    self.queryRequestForQuoteDetail();
                    self.quoteRow.addFiles = '';
                    //self.quoteRow.addContent = '';
                    self.actUploadAddFiles = '';
                    self.quoteRow.fileName = '';

                    this.checkSaveFile = false;
                }                
            });
        },
        queryRequestForQuoteDetail (){
            const self =this;            
            const param = {guid : this.quoteid , vendorId: this.currentVendorId ,excelFileBinary: 'bnVsbA==' , requestType : this.quoteRow.requestType};
            let url = `${this.$apiUrl_Quotation}/QueryRequestForQuoteDetail`;            
            this.axios.post(url, param).then((response) => {
                self.tableBody =[];
                const {status , statusMessage} = response.data;
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--讀取資料                    
                    const rows = response.data;
                    if(rows && rows.length >0 ){
                        self.tableBody = rows;
                    }
                    if(self.isMember){
                        self.getExcelTemplateForMember();
                    }
                }                
            });
        },
        getCssForTd (index){
            const c = this.headerCount;
            if(index >= c){
                return 'text-right calcCal';                
            }
            const numStartIndex = this.numDataColStartIndex;
            if(index > numStartIndex){
                return 'text-right';
            }else{
                return 'text-left';    
            }            
        },
        toolTipHandle (v,index){
            const c = this.headerCount;
            if(index >= c){
                return this.$toolTip(v);          
            }
            return '';//{content: ' ' ,active: false};
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
        showFileLink (it){            
            if(it.addFiles){
                return true;
            }
            if(this.actUploadAddFiles){
                return true;
            }
            return false;
        },
        getFileLink (it){
            const baseUrl = this.$apiUrl_Quotation;
            const guid= it.guid;
            if(it.addFiles){
                if(this.isMember){ //供應商身分                
                    return `${baseUrl}/DownloadVendorExcel/${guid}`;                    
                }else{//採購身分            
                    return `${baseUrl}/DownloadSampleExcel/${guid}`;
                }
            }
            return 'about:blank;';
        },
        getFileName (it){            
            if(it.addFiles){
                return this.fixFileName(it.addFiles);
            }
            return '';
        },  
        getUploadFileName (it){            
            if(this.isMember){ //供應商身分  
                if(it.addFiles){
                    return this.fixFileName(it.addFiles);
                }
                if(this.actUploadAddFiles){
                    return this.fixFileName(this.actUploadAddFiles)+ '(尚未存檔)';
                }
            }else {//採購身分   
                // if(it.addContent){
                //     return this.fixFileName(it.addContent);
                // }                
                if(this.actUploadAddFiles){
                    return this.fixFileName(this.actUploadAddFiles)+ '(尚未存檔)';
                }
                if(it.fileName){
                    return this.fixFileName(it.fileName);
                }
                if(it.addFiles){
                    return this.fixFileName(it.addFiles);
                }
            }
            return '';
        },
        getExcelTemplateForMember (){
            const list = [];            
            const row = this.quoteRow;
            list.push({requestType: row.requestType, requestKind: row.requestKind, excelFiles: row.fileName});
            this.excelTemplateList = list;
        }
    },    
    mounted() {        
        if(this.isMember){
            this.canQuoteDetail = true;            
        }else{
            this.$store.dispatch('getExcelTemplateList',{}).then((data) => {
                this.excelTemplateList = data;                     
            }); 
        }
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
.table tr td {
    text-align: center;
}
.attachment {
    display: flex;
    align-items: center;
    > p {
        margin-bottom: 0;
        margin-right: .5rem;
    }
    > .btn-edit {
        background-color: #343b55;
        color: white;
    }
}

.col-md-7 {
    padding-right: 0;
}

.col-md-5 {
    padding-left: 0;
}
.table th.vendorStyle {
   width:50px;
   max-width: 60px;
   text-overflow: ellipsis;
   overflow: hidden;
   white-space: nowrap;
}
.table .calcCal {
   background-color:yellow;
   color: red;
   font-weight: bolder;
}
a.fileLink {
    margin-right: 10px;
}
</style>